import { createApp } from 'vue'
// Bootstrap's stylesheets are imported BEFORE App.vue, and the order matters:
// App.vue's unscoped block sets `body { background-color: #f6f7f9 }`, which
// Bootstrap's own reboot rule for `body` would otherwise override. Under
// webpack the two never competed - Vue CLI split every node_modules
// stylesheet into chunk-vendors.css and linked it ahead of app.css, so
// Bootstrap always came first no matter what this file's import order was.
// Vite merges them into one stylesheet in import order, so the order has to
// be stated here instead.
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import App from './App.vue'
import { trackUsage } from './utils/usage.js'

// One anonymous ping per open → Bug Desk's Visitors tab (house module).
trackUsage('grand-family')

createApp(App).mount('#app')
